import { Helmet } from 'react-helmet';
import ReportbranchrevenueDetail
  from 'src/components/reportbranchrevenue-detail/ReportbranchrevenueDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import ReportbranchrevenueListToolbar from '../components/reportbranchrevenue-detail/ReportbranchrevenueListToolbar';

const ReportbranchrevenueList = () => (
  <>
    <Helmet>
      <title>Báo cáo doanh thu theo chi nhánh</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <ReportbranchrevenueListToolbar />
        <Box sx={{ pt: 3 }}>
          <ReportbranchrevenueDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default ReportbranchrevenueList;
